module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1336-min.db70ab5a.jpg";